<template>
  <div>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="ddlOrderType">Order Type</label>
            <select
              class="form-control"
              id="ddlOrderType"
              v-model="alert_step.alert_step_order_type_id"
              disabled
            >
              <option
                v-for="alert_step_order_type in alert_step_order_types"
                :key="alert_step_order_type.alert_step_order_type_id"
                v-bind:value="alert_step_order_type.alert_step_order_type_id"
              >{{ alert_step_order_type.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="ddlCommandType">Command Type</label>
            <select
              class="form-control"
              id="ddlCommandType"
              v-model="alert_step.alert_step_command_type_id"
            >
              <option value="0">Select..</option>
              <option
                v-for="alert_step_command_type in filtered_alert_step_command_types"
                :key="alert_step_command_type.alert_step_command_type_id"
                v-bind:value="alert_step_command_type.alert_step_command_type_id"
              >{{ alert_step_command_type.name }}</option>
            </select>
          </div>
          <div v-if="[1,7,8].includes(alert_step.alert_step_command_type_id)">
            <div class="form-group">
              <label for="ddlZone">Zone</label>
              <select class="form-control" id="ddlZone" v-model="alert_step.zone_id">
                <option value="0">Select..</option>
                <option
                  v-for="zone in filtered_zones"
                  :key="zone.zone_id"
                  v-bind:value="zone.zone_id"
                >[{{ zone.site.name }}] {{ zone.name }}</option>
              </select>
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 1">
            <SoundDropDownAndPreview tag="alert" v-model="alert_step.sound"></SoundDropDownAndPreview>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 2">
            <div class="form-group">
              <label for="txtBarixCommand">Barix Command</label>
              <input
                type="text"
                class="form-control"
                id="txtBarixCommand"
                v-model="alert_step.barix_command"
              />
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 3">
            <div class="form-group">
              <label for="numSleepDuration">Sleep Duration</label>
              <input
                type="number"
                class="form-control"
                id="numSleepDuration"
                v-model="alert_step.sleep_duration"
              />
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 4">
            <div class="form-group">
              <label for="ddlAlertSteps">Go to Step</label>
              <select class="form-control" id="ddlAlertSteps" v-model="alert_step.to_alert_step_id">
                <option value="0">Select..</option>
                <option
                  v-for="_alert_step in filtered_alert_steps"
                  :key="_alert_step.alert_step_id"
                  v-bind:value="_alert_step.alert_step_id"
                >{{ _alert_step.order }} - {{ _alert_step.alert_step_command_type.name }}</option>
              </select>
            </div>
          </div>
          <div v-if="alert_step.alert_step_command_type_id === 5">
            <div class="form-group">
              <label for="txtMessage">Message</label>
              <input class="form-control" type="text" id="txtMessage" v-model="alert_step.message" />
              <small
                class="form-text text-muted"
              >Contacts set to receive 'all alerts sms' will not show up in the below list but will automatically be sent the sms message.</small>
            </div>
          </div>
          <div v-if="[7,8].includes(alert_step.alert_step_command_type_id)">
            <div class="form-group">
              <label for="ddlVisuals">Visual</label>
              <select class="form-control" id="ddlVisuals" v-model="alert_step.advanced_visual_id">
                <option value="0">Select..</option>
                <option
                  v-for="advanced_visual in filtered_advanced_visuals"
                  :key="advanced_visual.advanced_visual_id"
                  v-bind:value="advanced_visual.advanced_visual_id"
                >{{ advanced_visual.name }}</option>
              </select>
            </div>
          </div>
          <br />
        </form>
      </div>
    </div>
    <div class="row" v-if="alert_step.alert_step_command_type_id === 5">
      <div class="col-12">
        <div class="row">
          <div class="col-5">
            <div class="form-group">
              <label for="txtPhoneToAddName">Name</label>
              <input
                class="form-control"
                type="text"
                id="txtPhoneToAddName"
                v-model="phone_to_add.name"
              />
            </div>
            <div class="form-group">
              <label for="txtPhoneToAddPhoneNumber">Phone Number</label>
              <vue-tel-input
                :onlyCountries="['US']"
                :validCharactersOnly="true"
                @input="updatePhoneNumberProperties"
                v-model="phone_to_add.phone_number.display_text"
              ></vue-tel-input>
            </div>
          </div>
          <div class="col-2 middle-btn-col">
            <button type="button" class="btn btn-light" @click="addPhoneNumber()">
              <i class="fa fa-arrow-right fa-fw" aria-hidden="true"></i>
            </button>
            <button type="button" class="btn btn-light" @click="removePhoneNumbers()">
              <i class="fa fa-trash fa-fw" aria-hidden="true"></i>
            </button>
          </div>
          <div class="col-5">
            <div class="card">
              <div class="card-header bg-hub-primary text-white">Phone Numbers</div>
              <div class="card-block">
                <select
                  multiple
                  class="form-control devices-select"
                  v-model="selected_phone_numbers"
                >
                  <option
                    v-for="alert_step_phone_number in alert_step.alert_step_phone_numbers"
                    v-bind:value="alert_step_phone_number.phone_number"
                    :key="alert_step_phone_number.phone_number"
                  >{{ alert_step_phone_number.name }} ({{ alert_step_phone_number.phone_number }})</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import SoundDropDownAndPreview from '../../components/SoundDropDownAndPreview'

export default {
  props: {
    alert_id: {
      type: [Number, String],
      required: true
    },
    alert_step_id: {
      type: [Number, String],
      required: true
    }
  },
  data: function () {
    return {
      phone_to_add: {
        name: '',
        phone_number: {
          display_text: '',
          properties: {
            isValid: false
          }
        }
      },
      selected_phone_numbers: []
    }
  },
  components: { SoundDropDownAndPreview },
  watch: {
    alert_step_id (newAlertStepId) {
      this.$store.dispatch('getAlertStep', newAlertStepId)
    },
    alert_id (newAlertId) {
      this.$store.dispatch('getAlertSteps', newAlertId)
    }
  },
  computed: {
    ...mapGetters({
      alert: 'singleAlert',
      alert_step: 'singleAlertStep',
      alert_steps: 'allAlertSteps',
      alert_step_order_types: 'allAlertStepOrderTypes',
      alert_step_command_types: 'allAlertStepCommandTypes',
      feature_sms_enabled: 'featureSMSEnabled',
      feature_sms_max_phone_numbers: 'featureSMSMaxPhoneNumbers',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled',
      advanced_visuals: 'allAdvancedVisuals',
      zones: 'allZones',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_zones: function () {
      let context = this
      return this.zones.filter(function (zone) {
        if (
          zone.site_id === context.scoped_site_id ||
          context.scoped_site_id === 1
        ) {
          if ([7, 8].includes(context.alert_step.alert_step_command_type_id)) {
            return zone.zone_type_id === 4
          } else {
            return zone.zone_type_id !== 4
          }
        }
      })
    },
    filtered_alert_step_command_types: function () {
      let context = this

      return this.alert_step_command_types.filter(function (commandType) {
        if (context.feature_sms_enabled) {
          if (commandType.alert_step_command_type_id === 5) {
            if (context.alert_step.alert_step_command_type_id !== 5) {
              return false
            }
          }
        }

        if (commandType.alert_step_command_type_id === 6) {
          return false
        }

        if (context.alert.device_id === null) {
          if (commandType.alert_step_command_type_id === 2) {
            return false
          }
        }

        return true
      })
    },
    filtered_alert_steps: function () {
      return this.alert_steps.filter(
        alertStep =>
          alertStep.alert_id === this.alert.alert_id &&
          alertStep.alert_step_order_type_id ===
            this.alert_step.alert_step_order_type_id
      )
    },
    filtered_advanced_visuals: function () {
      return this.advanced_visuals.filter(v => v.alert_id === this.alert.alert_id)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getAlertStepOrderTypes')
    this.$store.dispatch('getAlertStepCommandTypes')
    this.$store.dispatch('getZones')
  },
  methods: {
    updatePhoneNumberProperties (num, data) {
      this.phone_to_add.phone_number.properties = data
    },
    addPhoneNumber () {
      if (
        this.alert_step.alert_step_phone_numbers.length <
        Number(this.feature_sms_max_phone_numbers)
      ) {
        if (!_.isEmpty(this.phone_to_add.name)) {
          if (this.phone_to_add.phone_number.properties.isValid) {
            this.alert_step.alert_step_phone_numbers.push({
              alert_step_id: this.alert_step_id,
              name: this.phone_to_add.name,
              phone_number: this.phone_to_add.phone_number.properties.number.replace(
                /\s/g,
                ''
              )
            })

            this.phone_to_add.name = ''
            this.phone_to_add.phone_number = {
              display_text: '',
              properties: { isValid: false }
            }
          } else {
            alert('Please enter a valid phone number.')
          }
        } else {
          alert('Please enter a name for the phone number.')
        }
      } else {
        alert(
          'The limit of ' +
            this.feature_sms_max_phone_numbers +
            ' phone numbers has been reached.'
        )
      }
    },
    removePhoneNumbers () {
      for (let i = 0; i < this.selected_phone_numbers.length; i++) {
        let selectedPhoneNumber = this.selected_phone_numbers[i]
        let phoneNumberToRemove = this.alert_step.alert_step_phone_numbers.find(
          function (ele) {
            if (ele.phone_number === selectedPhoneNumber) {
              return true
            }
          }
        )
        this.alert_step.alert_step_phone_numbers.splice(
          this.alert_step.alert_step_phone_numbers.indexOf(phoneNumberToRemove),
          1
        )
      }
    },
    submit () {
      this.$store.dispatch('addEditAlertStep', {
        alert_step: this.alert_step
      })
    }
  }
}
</script>

<style scoped>
</style>
